import { useEffect, useState } from "react";
import { Form, Input, Modal, App, Typography } from "antd";

import { createKeyCategory, updateKeyCategory } from "@/api/nspd";

const { Text } = Typography;

const NSPDKeyCategoryModal = ({ visible, category, onCancel, onSuccess }) => {
  const { message } = App.useApp();

  const [form] = Form.useForm();

  const [error, setError] = useState(null);

  const [isSaving, setIsSaving] = useState(false);

  const isEdit = Boolean(category?.uuid);

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        name: category?.name || "",
        description: category?.description || "",
      });
    } else {
      form.resetFields();
    }
  }, [visible, category, form]);

  const handleCancel = () => {
    setError(null);
    form.resetFields();
    onCancel();
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      setIsSaving(true);
      setError(null);

      if (isEdit) {
        await updateKeyCategory({ ...values, uuid: category.uuid });
        message.success("Категория обновлена");
      } else {
        await createKeyCategory(values);
        message.success("Категория создана");
      }

      form.resetFields();
      onSuccess?.();
      onCancel();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal
      title={
        isEdit ? "Редактирование категории ключей" : "Создание категории ключей"
      }
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={isSaving}
      okText={isEdit ? "Сохранить" : "Создать"}
      cancelText="Отмена"
      destroyOnHidden
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Название"
          name="name"
          rules={[
            {
              required: true,
              whitespace: true,
              message: "Введите название категории",
            },
          ]}
        >
          <Input placeholder="Введите название категории" />
        </Form.Item>

        <Form.Item label="Описание" name="description">
          <Input.TextArea placeholder="Введите описание" rows={4} allowClear />
        </Form.Item>

        {error && <Text type="danger">{error}</Text>}
      </Form>
    </Modal>
  );
};

export default NSPDKeyCategoryModal;
